import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { productWarehousesService } from "../../../../shared/services";
import React from "react";
import { TableProperties } from "../../../../shared/components/ui/Table/types";
import { useSelector } from "react-redux";
import { selectproductWarehousesRefreshTable } from "../../../../redux/selectors/productWarehouses.selectors";
import useAppDispatch from "../../../../redux/hooks/useAppDispatch";
import { refreshTableAddressesUser } from "../../../../redux";

const { confirm } = Modal;

export const useDeleteProductWarehouse = () => {
  const dispatch = useAppDispatch();
  const [tableProps, setTableProps] = React.useState<TableProperties>();
  const isproductWarehousesRefreshTable= useSelector(
    selectproductWarehousesRefreshTable
  );
  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar el producto con el id: ${valId} de esta bodega`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar producto" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar producto",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await productWarehousesService.remove(valId)
          .then((_res) => {
              notify.success(`Se ha borrado con éxito el producto de la bodega con id:${valId}`);
              tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (isproductWarehousesRefreshTable) {
      tableProps?.refresh();
      dispatch(refreshTableAddressesUser(false));
    }
  }, [isproductWarehousesRefreshTable]);
  
  return {
    tableProps,
    showDeleteConfirm,
    setTableProps,
  };
};
